import React, { useEffect, useRef, Component, useState } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { Watch } from "react-loader-spinner";

import { useHistory, useParams, Link } from 'react-router-dom';
import { ApiService } from '../../containers/Services/apiservice';

const BlogDetail = () => {
  let history = useHistory();
  const { slug } = useParams();
  let apiServices = new ApiService();
  const [blogData, setblogData] = useState({ blog_name: '', blog_desc: '', blog_image: '' });
  const [category, setcategoryData] = useState([]);
  const [tags, settagsData] = useState([]);
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [blogsData, setBlogsData] = useState([])
  const [baseUrl, setBaseUrl] = useState('');
  const didMountRef = useRef(true);
  useEffect(() => {
    if (didMountRef.current) {
      setSpinnerLoading(true);
      const dataString = {
        "slug": slug
      }
      apiServices.getblogbyslug(dataString).then(res => {
        if (res.data.status == 'success') {
          setBaseUrl(res.data.baseurl);
          setblogData({
            blog_name: res.data.data.blog_name,
            blog_image: res.data.data.blog_image,
            blog_desc: res.data.data.blog_desc,
          })
          setcategoryData(res.data.data.blog_category_id)
          settagsData(res.data.data.blog_tag_id)
          setSpinnerLoading(false);
        }
      })
      apiServices.getfeaturedblogs()
        .then(res => {
          if (res.data.status == 'success') {
            setBlogsData(res.data.data);
            setBaseUrl(res.data.baseurl);
            return;
          }
        })
    }
    didMountRef.current = false;
  });
  return (
    <div>
      <Header />
      <section>
        <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
          <div className='overlay-box'>
            <Watch
              color="#ffffff"
              visible={spinnerLoading}
            />
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-9">
              <div className="blog-details">
                <div className="blog-details-img mg-b-15">
                  {blogData.blog_image != "" ?
                    <img src={baseUrl + blogData.blog_image} alt="" />
                    : ''
                  }
                </div>
                <div className="blog-meta-category">
                  <ul>
                    {category.map(key =>
                      <li><Link to={`/blog-category/${key.category_slug}`}>{key.category_name}</Link></li>)
                    }
                  </ul>
                </div>
                <h1 className="blog-details-title">{blogData.blog_name}</h1>
                <div className="blog-desc" dangerouslySetInnerHTML={{ __html: blogData.blog_desc }}></div>
                <h6>Tags</h6>

                <div className="blog-meta-tags mg-b-20">
                  <ul>
                    {
                      tags.map(key =>
                        <li><Link to={`/blog-tags/${key.tag_slug}`}>{key.tag_name}</Link></li>)
                    }
                  </ul>
                </div>
                <h6>Share this post on social media</h6>
                <div className="addthis_inline_share_toolbox"></div>
                <div id="disqus_thread" className="mg-t-20"></div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="blog-sidebar">
                <h3> Recommendations</h3>
                {
                  blogsData.map(key =>
                    <div className="col-md-14" >
                      <div className="blogbox">
                        <div className="blogbox-img">
                          <Link to={`/blog-detail/${key.blog_slug}`}>
                            {
                              key.blog_image != '' ? <img src={baseUrl + key.blog_image} /> : <img src="https://www.codexocoder.com/2022/goalstox/public/img/uploads/blog_image/1649328888.webp" />
                            }
                          </Link>
                        </div>
                        <div className="blogbox-content">
                          <div className="blog-meta">
                            <div className="blog-meta-date">{key.datetime} </div>
                            <div className="blog-meta-category">
                              <ul>
                                {
                                  key.blog_category_id.map(cat => <li><Link to={`/blog-category/${cat.category_slug}`}>{cat.category_name}</Link></li>)
                                }
                              </ul>
                            </div>
                          </div>
                          <div className="blogbox-title">  <Link to={`/blog-detail/${key.blog_slug}`}>{key.blog_name}</Link></div>
                        </div>
                      </div>
                    </div>
                  )
                }
              </div>

            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default BlogDetail;